import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, _toDisplayString(_ctx.item.text), 1),
    _cache[0] || (_cache[0] = _createElementVNode("td", { class: "text-end" }, null, -1))
  ], 64))
}